import styled from 'styled-components/native'

export const Page = styled.View(({ theme }) => ({
  backgroundColor: theme.designSystem.color.background.default,
  flex: 1,
}))
